<a mat-icon-button class="notification-button" matTooltip="Recent Notifications"
   [matMenuTriggerFor]="notificationsMenu">
  <mat-icon class="badge" color="warn" *ngIf="notifications?.length > 0">fiber_manual_record</mat-icon>
  <mat-icon class="header-icon">notifications</mat-icon>
</a>

<mat-menu #notificationsMenu class="notifications-menu">
  <div mat-menu-item class="progress-wrapper" *ngIf="showProgress">
    <span class="k-i-loading k-icon"></span>
  </div>

  <div mat-menu-item *ngIf="notifications?.length == 0">
    <span>No New Notifications</span>
  </div>

  <div class="text-right" *ngIf="notifications?.length > 0">
    <button mat-flat-button (click)="clearAllNotifications()">Clear All</button>
  </div>
  <ng-container *ngFor="let notification of notifications">
    <a mat-menu-item (click)="onRowClick($event, notification)" class="notification-item" style="width: 100%">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxFlex fxLayout="row" fxLayoutAlign="start center"
             *ngIf="notification.eventType === 'sms' || notification.eventType === 'pro-sms'">
          <mat-icon class="item-icon">textsms</mat-icon>
          <div class="item-body" *ngIf="!!notification.tnFrom">
            <span>{{ notification.tnTo | phoneNumber }}</span>
            <br>
            <span>{{ notification.badge }} New SMS from {{ notification.tnFrom | phoneNumber }}</span>
          </div>
          <div class="item-body" *ngIf="!notification.tnFrom">
            <span>{{ notification.badge }} New SMS to {{ notification.tnTo | phoneNumber }}</span>
          </div>
        </div>
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" *ngIf="notification.eventType === 'fax-in'">
          <mat-icon class="item-icon">print</mat-icon>
          <div class="item-body" *ngIf="!!notification.tnFrom">
            <span>{{ notification.tnTo | phoneNumber }}</span>
            <br>
            <span>{{ notification.badge }} New Fax from {{ notification.tnFrom | phoneNumber }}</span>
          </div>
          <div *ngIf="!notification.tnFrom">
            <span>{{ notification.badge }} New Fax to {{ notification.tnTo | phoneNumber }}</span>
          </div>
        </div>
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" *ngIf="notification.eventType === 'fax-out'">
          <mat-icon class="item-icon">print</mat-icon>
          <div class="item-body" *ngIf="!!notification.tnFrom">
            <span>{{ notification.tnFrom | phoneNumber }}</span>
            <br>
            <span>{{ notification.badge }} Fax sent to {{ notification.tnTo | phoneNumber }}</span>
          </div>
        </div>
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" *ngIf="notification.eventType === 'broadcast'">
          <mat-icon class="item-icon">podcasts</mat-icon>
          <div class="item-body">
            <span>{{ notification.messageText }}</span>
          </div>
        </div>
        <div fxFlex fxLayout="row" fxLayoutAlign="start center" *ngIf="notification.eventType === 'export'">
            <mat-icon class="item-icon">download</mat-icon>
            <div class="item-body" fxFlex>
              <span>Download Exported File</span>
            </div>
        </div>
        <div class="item-info">
          <time class="sidebar-list-item-time" datetime="2018-05-01 13:47">
            {{ notification.time | humanizedDuration }}
          </time>
        </div>
      </div>
    </a>
  </ng-container>
</mat-menu>
